export default "__VITE_ASSET__C2Y74xjW__"